In order to use pganalyze you need to install the [pganalyze collector](https://github.com/pganalyze/collector)
in your environment, either on the database server directly, or a container / VM
that can connect to it when using managed database services. The collector sends
query data and other statistics on a continuous basis to the pganalyze cloud
service, or to your pganalyze Enterprise Server installation.

The minimum supported PostgreSQL version is 10.
